import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=d1f16650&scoped=true&"
import script from "./Paginator.ts?vue&type=script&lang=js&"
export * from "./Paginator.ts?vue&type=script&lang=js&"
import style0 from "./Paginator.vue?vue&type=style&index=0&id=d1f16650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f16650",
  null
  
)

export default component.exports